



































import {
  defineComponent,
  ref,
  Ref,
  onMounted,
  watch,
} from '@vue/composition-api';
import EventBus, { ACTIONS } from '@/EventBus';

export interface SnackbarOptions {
  text: string;
  errorMessage?: string;
  error?: boolean;
  onAction?: () => void;
  actionText?: string;
}

export default defineComponent({
  setup() {
    const message = ref('');
    const errorMessage = ref<string | null>('');
    const showSnackbar = ref(false);
    const snackbarColor: Ref<string | undefined> = ref(undefined);
    const buttonColor = ref('info');
    const top = ref(false);
    const actionText = ref('Close');
    const onAction: Ref<() => void> = ref(() => {});
    const showDetails = ref(false);

    onMounted(() => {
      EventBus.$on(ACTIONS.TOAST, (options: SnackbarOptions) => {
        showSnackbar.value = true;
        message.value = options.text;
        errorMessage.value = options.errorMessage || null;
        snackbarColor.value = options.error ? 'error' : undefined;
        top.value = !!options.error;
        buttonColor.value = snackbarColor.value === 'error' ? 'white' : 'info';
        onAction.value = options.onAction || (() => {});
        actionText.value = options.actionText || 'Close';
      });

      EventBus.$on(ACTIONS.CLOSE_TOAST, () => {
        showSnackbar.value = false;
      });
    });

    watch(showSnackbar, () => {
      if (!showSnackbar.value) {
        showDetails.value = false;
      }
    });

    return {
      showSnackbar,
      message,
      errorMessage,
      snackbarColor,
      buttonColor,
      top,
      actionText,
      onAction,
      showDetails,
    };
  },
});
